/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

/**
 * An alternative meaning a field takes on when a sibling field holds a given
 * value.
 *
 * `event_data` in an `event` message is a plain uint16 in general, but means
 * `gear_change_data` when `event` is `rear_gear_change`. Each such alternative
 * carries its own type, scale, offset, units and components, and applies only
 * when one of its [maps] matches.
 */
public class SubField(
    public val name: String,
    public val baseType: BaseType,
    public val scale: Double,
    public val offset: Double,
    public val units: String,
) {
    public val maps: MutableList<SubFieldMap> = mutableListOf()
    public val components: MutableList<FieldComponent> = mutableListOf()

    public val hasComponents: Boolean get() = components.isNotEmpty()

    internal constructor(other: SubField) : this(other.name, other.baseType, other.scale, other.offset, other.units) {
        maps.addAll(other.maps)
        other.components.forEach { components.add(FieldComponent(it)) }
    }

    public fun addMap(refFieldNum: UByte, refFieldValue: Any?) {
        maps.add(SubFieldMap(refFieldNum, FitValues.toLong(refFieldValue)))
    }

    public fun addComponent(component: FieldComponent) {
        components.add(component)
    }

    /** True when [mesg] holds a reference field value that selects this subfield. */
    public fun canMesgSupport(mesg: Mesg): Boolean = maps.any { it.canMesgSupport(mesg) }
}

/** One `(reference field, value)` pair that activates a [SubField]. */
public class SubFieldMap(
    public val refFieldNum: UByte,
    public val refFieldValue: Long,
) {
    public fun canMesgSupport(mesg: Mesg): Boolean {
        val field = mesg.getField(refFieldNum) ?: return false
        val value = field.getValue(0, SubFieldSelector.MainField) ?: return false
        // Reference values are always integral in the profile; a float here
        // would be a malformed file, and comparing it as a Long is harmless.
        return FitValues.toLong(value) == refFieldValue
    }
}
